import { combineReducers } from "@reduxjs/toolkit";
import { persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage";
import authReducer from "./slices/authSlice";
import schoolReducer from "./slices/schoolSlice";
import courseReducer from "./slices/courseSlice";
import studentLogReducer from "./slices/studentLogSlice";
import schoolLogReducer from "./slices/schoolLogSlice";
import studentReducer from "./slices/studentSlice";
import teacherReducer from "./slices/teacherSlice";
import assignmentReducer from "./slices/assignmentSlice";
import feedbackReducer from "./slices/feedbackSlice";
import submissionReducer from "./slices/submissionSlice";
import dashboardReducer from "./slices/dashboardSlice";
import schoolDashboardReducer from "./slices/schoolDashboardSlice";
import teacherDashboardReducer from "./slices/teacherDashboardSlice";
import studentDashboardReducer from "./slices/studentDashboardSlice";
import studentAssignmentsReducer from "./slices/studentAssignmentsSlice";
import studentClassDashboardReducer from "./slices/studentClassDashboardSlice";
import studentClassAssignmentsReducer from "./slices/studentClassAssignmentsSlice";
import groupSchoolAdminReducer from "./slices/groupSchoolAdminSlice";
// Clean up commented out code
// import timeEntriesReducer from "./slices/timeEntriesSlice";
// import projectTrackingReducer from "./slices/projectTrackingSlice";
// import timerReducer from "./slices/timerSlice";
// import timeEntryReducer from "./slices/timeEntrySlice";

// Configure persistence for course slice to persist navigationSource
const coursePersistConfig = {
  key: 'course',
  storage,
  whitelist: ['navigationSource'], // Only persist navigationSource field
};

// Define the app reducer with all individual reducers
const appReducer = combineReducers({
  auth: authReducer,
  schools: schoolReducer,
  course: persistReducer(coursePersistConfig, courseReducer),
  studentLog: studentLogReducer,
  schoolLog: schoolLogReducer,
  students: studentReducer,
  teacher: teacherReducer,
  assignments: assignmentReducer,
  schoolDashboard: schoolDashboardReducer,
  teacherDashboard: teacherDashboardReducer,
  studentDashboard: studentDashboardReducer,
  studentAssignments: studentAssignmentsReducer,
  studentClassDashboard: studentClassDashboardReducer,
  studentClassAssignments: studentClassAssignmentsReducer,
  feedbacks: feedbackReducer,
  submissions: submissionReducer,
  dashboard: dashboardReducer,
  groupSchoolAdmins: groupSchoolAdminReducer,
  // users: userReducer,
  // clients: clientReducer,
  // projects: projectReducer,
  // timeEntries: timeEntriesReducer,
  // projectTracking: projectTrackingReducer,
  // timer: persistReducer(timerPersistConfig, timerReducer),
  // timeEntry: persistReducer(timeEntryPersistConfig, timeEntryReducer),
});

// Root reducer that can handle the logout action to clear all state
const rootReducer = (state: any, action: any) => {
  return appReducer(state, action);
};

export default rootReducer;
